const updates = [
  { date: '2026-07-30', title: '暑期档热映专题上线，《星际穿越2》《深海危机》等大片抢先看', tag: '新片上线' },
  { date: '2026-07-28', title: '樱花视频热播剧《长安十二时辰》全集已收录，会员专享画质免费看', tag: '剧集更新' },
  { date: '2026-07-25', title: '糖心视频移动端APP 3.0版本发布，新增画中画和倍速播放功能', tag: '产品动态' },
  { date: '2026-07-22', title: '西瓜视频独家综艺《了不起的挑战》新一季上线，全网最全合辑', tag: '综艺上新' },
  { date: '2026-07-18', title: '樱桃视频高分纪录片《地球脉动III》已收录，4K超清画质体验', tag: '纪录片' },
  { date: '2026-07-15', title: '平台新增智能推荐算法，根据观影记录精准推送您感兴趣的内容', tag: '功能升级' },
  { date: '2026-07-10', title: '糖豆视频热门动漫《鬼灭之刃》全季收录，日配中字同步更新', tag: '动漫专题' },
  { date: '2026-07-05', title: '糖心视频日活跃用户突破500万，感谢每一位观众的支持与陪伴', tag: '平台资讯' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-primary-500 uppercase tracking-wide mb-2">最新动态</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">糖心视频平台最新内容与资讯更新</p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[29px] md:-left-[33px] w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100"></div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}